import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AuthenticatedUser } from '../models/client-user.model';

const USER_KEY   = 'klemantina_user_data';
const EXPIRY_KEY = 'klemantina_user_expiry';

@Injectable({
  providedIn: 'root'
})
export class UserAuthService {
  private currentUserSubject = new BehaviorSubject<AuthenticatedUser | null>(null);
  public currentUser$ = this.currentUserSubject.asObservable();

  constructor() {
    this.loadStoredUser();
  }

  private loadStoredUser(): void {
    if (!this.isAuthenticated()) return;

    const userData = localStorage.getItem(USER_KEY);
    if (userData) {
      try {
        const user = JSON.parse(userData) as AuthenticatedUser;
        this.currentUserSubject.next(user);
      } catch {
        this.clearLocalState();
      }
    }
  }

  // expiresAt: Unix ms timestamp returned by the server in the verify-otp response
  setSession(user: AuthenticatedUser, expiresAt: number): void {
    localStorage.setItem(USER_KEY,   JSON.stringify(user));
    localStorage.setItem(EXPIRY_KEY, String(expiresAt));
    this.currentUserSubject.next(user);
  }

  isAuthenticated(): boolean {
    const expiry = Number(localStorage.getItem(EXPIRY_KEY));
    return !!expiry && Date.now() < expiry;
  }

  // Call after the logout API request clears the HttpOnly cookie server-side
  clearLocalState(): void {
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem(EXPIRY_KEY);
    this.currentUserSubject.next(null);
  }

  getCurrentUser(): AuthenticatedUser | null {
    return this.currentUserSubject.value;
  }

  logout(): void {
    this.clearLocalState();
  }
}
